import PropTypes from 'prop-types'
import { dassSeverity } from '../../../data/dassQuestions'

const DIMS = [
  { key: 'depression', name: 'Depression' },
  { key: 'anxiety', name: 'Anxiety' },
  { key: 'stress', name: 'Stress' },
]
const BANDS = ['normal', 'mild', 'moderate', 'severe', 'extremelySevere']
const BAND_LABEL = { normal: 'normal', mild: 'mild', moderate: 'moderate', severe: 'severe', extremelySevere: 'extreme' }

function MentalHealthSection({ scores, severities }) {
  return (
    <section className="section" aria-labelledby="mh-h">
      <div className="section__head">
        <h2 id="mh-h">Depression, anxiety and stress</h2>
        <p className="section__desc">Full DASS-21 scores placed on the published severity bands. This is a screen, not a diagnosis; the bands are where clinicians would start a conversation.</p>
      </div>
      <div>
        {DIMS.map((d) => {
          const sev = severities[d.key]
          const activeIndex = BANDS.indexOf(sev.category)
          const max = dassSeverity[d.key].extremelySevere.min
          return (
            <div key={d.key} className="band">
              <div className="band__top">
                <span className="band__name">{d.name}</span>
                <span className="band__score"><strong>{scores[d.key]}</strong> · {sev.label.toLowerCase()}</span>
              </div>
              <div className="band__track" role="img" aria-label={`${d.name} score ${scores[d.key]}, ${sev.label}`}>
                {BANDS.map((b, i) => (
                  <span key={b} className={`band__seg${i === activeIndex ? ' band__seg--active' : ''}`} />
                ))}
              </div>
              <div className="band__labels" aria-hidden="true">
                {BANDS.map((b, i) => {
                  const range = dassSeverity[d.key][b]
                  const text = b === 'extremelySevere' ? `${max}+` : `${range.min}–${range.max}`
                  return (
                    <span key={b} className={i === activeIndex ? 'is-active' : ''}>
                      {BAND_LABEL[b]}<br />{text}
                    </span>
                  )
                })}
              </div>
              <p className="band__desc">{sev.description}</p>
            </div>
          )
        })}
      </div>
    </section>
  )
}

MentalHealthSection.propTypes = {
  scores: PropTypes.object.isRequired,
  severities: PropTypes.object.isRequired,
}

export default MentalHealthSection
